import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { DataencryptionService } from './dataencryption.service';
import { Router } from '@angular/router';

@Injectable()
export class LocalstorageService {

  UIDToEncrypt: string;
  encryptedUID: any;

  tokenToEncrypt: string;
  encryptedToken: any;

  constructor(private _cookieService: CookieService, private _dataEnc: DataencryptionService,
    private _router: Router) { }

  // This method if for adding data to local storage and cookies
  createLocalStorage(userDetails: any, electionSchedule: any, localStoreElement: string[]) {

    // Encrypt UID using AES Encryption
    this.UIDToEncrypt = userDetails.uId;
    this.encryptedUID = this._dataEnc.encryptUID(this.UIDToEncrypt);

    // Encrypt TOKEN using AES Encryption
    this.tokenToEncrypt = userDetails.token;
    this.encryptedToken = this._dataEnc.encryptToken(this.tokenToEncrypt);

    // console.log("localStoreElement called 29",localStoreElement)
    // for(let j=0;j < localStoreElement.length; j++) {
    //   console.log("localStoreElement : ",localStoreElement[j]);
      
    // }
   
    
    for (let i = 0; i < localStoreElement.length; i++) {
      if (localStoreElement[i] === 'fullname') {
        localStorage.setItem('fullname', userDetails.firstName + ' ' + userDetails.lastName);
      } else if (localStoreElement[i] === 'epDate') {
        localStorage.setItem('epDate', JSON.stringify(electionSchedule));
      } else if (localStoreElement[i] === 'userMobileNo') {
        this._cookieService.set('userMobileNo', userDetails.userMobileNo);
      } else if (localStoreElement[i] === 'token') {
        this._cookieService.set('token', this.encryptedToken, 0.041666667);
      } else if (localStoreElement[i] === 'uId') {
        this._cookieService.set('uId', this.encryptedUID, 0.041666667);
      }  else {
        localStorage.setItem(localStoreElement[i], userDetails[localStoreElement[i]]);
      }
    }

    this._router.navigateByUrl('/userview/dashboard');
  }

  createLocalStorageSEC(userDetails: any, localStoreElement: string[]) {

    // Encrypt UID using AES Encryption
    this.UIDToEncrypt = userDetails.uId;
    this.encryptedUID = this._dataEnc.encryptUID(this.UIDToEncrypt);

    // Encrypt TOKEN using AES Encryption
    this.tokenToEncrypt = userDetails.token;
    this.encryptedToken = this._dataEnc.encryptToken(this.tokenToEncrypt);

    for (let i = 0; i < localStoreElement.length; i++) {
      if (localStoreElement[i] === 'fullname') {
        localStorage.setItem('fullname', userDetails.firstName + ' ' + userDetails.lastName);
      } else if (localStoreElement[i] === 'userMobileNo') {
        this._cookieService.set('userMobileNo', userDetails.userMobileNo);
      } else if (localStoreElement[i] === 'token') {
        this._cookieService.set('token', this.encryptedToken, 0.041666667);
      } else if (localStoreElement[i] === 'uId') {
        this._cookieService.set('uId', this.encryptedUID, 0.041666667);
      }  else {
        localStorage.setItem(localStoreElement[i], userDetails[localStoreElement[i]]);
      }
    }

    this._router.navigateByUrl('/userview/dashboard');
  }

  // To clear the data in localstorage as well as in cookie while logging out
  destroyLocalStorage(localStoreElement: string[]) {

    for (let i = 0; i < localStoreElement.length; i++) {
      if (localStoreElement[i] === 'userMobileNo' || localStoreElement[i] === 'token' || localStoreElement[i] === 'uId') {
        this._cookieService.delete(localStoreElement[i]);
      } else {
        localStorage.removeItem(localStoreElement[i]);
      }
    }

    this._router.navigateByUrl('/login');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/localstorage.service.ts